<template>
  <li
    class="covid-search-cards-list--item"
  >
    <div class="card" :class="boxInfo.getEstablishmentLabel() ? 'with-type' : ''" :data-nid="boxInfo.getNodeId()" :data-establishmentid="boxInfo.getEstablishmentId()">
      <div class="classic-info">
        <h3 class="ps-name">
          {{ boxInfo.getName() }} <span v-if="boxInfo.getProfession()" class="jobname"> - {{ boxInfo.getProfession() }}</span>
        </h3>
        <p v-if="boxInfo.getEstablishmentLabel()" class="ps-type">{{ boxInfo.getEstablishmentLabel() }}</p>
        <p class="card-elm-item" v-if="isfilterDistanceChecked && boxInfo.getDistance(currentLocation)">
          <span><i class="icon icon-distance" aria-hiden="true"><span class="sr-only">Distance</span></i> {{ boxInfo.getDistance(currentLocation) }} km </span>
        </p>
        <p v-if="boxInfo.getPrecisionTypeEg()" class="precision2">
          {{ boxInfo.getPrecisionTypeEg() }}
        </p>
        <p v-if="dispositifAllerVers" class="dispositif-aller-vers">
          Dispositif aller vers
        </p>
        <p class="address-lines">
          <span class="address-line-1">{{ boxInfo.getAddress() }} </span
          ><br /><span class="address-zip"
            >{{ boxInfo.getPostalCode() }}&nbsp;</span
          >
          <span class="address-city">{{ boxInfo.getCity() }}</span>
        </p>
      </div>
      <div v-if="boxInfo.getlabelsVaccinationDisplayed('all').length != 0" class="wrpCreneau-info">
        <div
          v-if="boxInfo.getlabelsVaccinationDisplayed('vaccinGrippe')"
          class="type-vaccin vaccin-grippe">
          {{ boxInfo.getlabelsVaccinationDisplayed('vaccinGrippe') }}
        </div>
        <div
          v-if="boxInfo.getlabelsVaccinationDisplayed('vaccin511')"
          class="type-vaccin vaccin-grippe">
          {{ boxInfo.getlabelsVaccinationDisplayed('vaccin511') }}
        </div>
        <div
          v-if="boxInfo.getlabelsVaccinationDisplayed('vaccinNovavax')"
          class="type-vaccin vaccin-grippe">
          {{ boxInfo.getlabelsVaccinationDisplayed('vaccinNovavax') }}
        </div>
      </div>
      <div class="others-info" v-if="boxInfo.getTestTypes()?.length">
        <div v-if="boxInfo.getTestTypes()?.length" class="separator screening-test-type">
          <p class="screening-test-type--label">Types de tests pratiqués :</p>
          <ul class="resetul screening-test-type--list">
            <li
              class="screening-test-type--item"
              v-for="(test, index) in boxInfo.getTestTypes()"
              :key="test"
            >
             <span v-if="index!==0">|</span> {{ test }}
            </li>
          </ul>
        </div>
      </div>
      <div class="ps-links">
        <span v-for="phone in boxInfo.getPhones()" :key="phone" class="ps-phone phone">
          <a
            :aria-label="`Appeler le ${phone}`"
            :href="`tel:${phone.replaceAll(' ','')}`"
            >{{ phone }}</a
          ></span
        >
        <span v-if="boxInfo.getWebSite()" class="ps-phone phone">
          <a
            aria-label="Prendre rendez-vous"
            :href="boxInfo.getWebSite()"
            >Prendre rendez-vous</a
          ></span
        >
      </div>
      <div v-if="boxInfo.getReceptionModality()" class="ps-more">
        <button
          class="btn-collapse btn-collapse-vue"
          type="button"
          :aria-expanded="collapsed"
          :aria-controls="idModal"
          @click="collapsed = !collapsed"
        >
          Modalités d'accueil
        </button>
        <div :id="idModal" class="collapse" :class="{'collapsed': !collapsed}">
          <div v-html="$sanitize(boxInfo.getReceptionModality())" />
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { ref, inject, computed } from 'vue';
import { hashGenerator } from '@/helpers';
import GeolocationHook from '@/hooks/geoLocation.hook';

export default {
  props: {
    boxInfo: {
      type: Object,
      default: () => ({}),
    },
    pageOrigin: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const idModal = hashGenerator();
    const collapsed = ref(false);
    const { getCurrentLocation } = GeolocationHook();
    const currentLocation = ref(getCurrentLocation());
    const isfilterDistanceChecked = inject('isfilterDistanceChecked');
    const dispositifAllerVers = computed(() => props?.boxInfo?.testType?.includes('Dispositif aller vers') || props?.boxInfo?.labelNames?.includes('Dispositif aller vers'));
    return {
      displayComplementryInfo: ref(false),
      idModal,
      currentLocation,
      isfilterDistanceChecked,
      collapsed,
      dispositifAllerVers,
    };
  },
};
</script>
